import {
	SWITCH_IMPOSIUM_COMPOSITION,
	RENAME_CREATIVE,
	DUPLICATE_CREATIVE,
	DOWNLOAD_CREATIVE,
	DOWNLOAD_CREATIVE_SUMMARY,
	VIDEO_SPECS,
	SELECT_NEW_VIDEO,
	CLASSIFY,
	PREDICTIVE_SCORING,
	DELETE_CREATIVE
} from "./EllipsisActions";

export const TRANSCODED_DVAST_ELLIPSIS_ACTION_LIST = [
	[
		SWITCH_IMPOSIUM_COMPOSITION,
	],
	[
		RENAME_CREATIVE,
		DUPLICATE_CREATIVE,
		DOWNLOAD_CREATIVE,
		DOWNLOAD_CREATIVE_SUMMARY,
	],
	[
		VIDEO_SPECS,
	],
	[
		SELECT_NEW_VIDEO,
	],
	[
		CLASSIFY,
		PREDICTIVE_SCORING,
	],
	[
		DELETE_CREATIVE,
	],
];
